import { PackService } from '@stockcare-services/pack-service/pack.service';
import { IDataStorage } from '@stockcare-storage/internal/data-storage';
import { InternalIndex } from '@stockcare-storage/internal/internal-index';
import { InternalTable } from '@stockcare-storage/internal/internal-table';
import { PackMaterial } from '@stockcare-storage/pack-material-service/pack-material';
import { PackServices } from '@stockcare-storage/pack-material-service/pack-service';

export class Pack implements IDataStorage {
  barcodeIndex: InternalIndex = new InternalIndex('barcode', 'barcode', true, false);
  idIndex: InternalIndex = new InternalIndex('id', 'id', true, false);
  tableDefinition: InternalTable = new InternalTable('Pack', 'id', false, [this.barcodeIndex, this.idIndex]);

  id: number;
  barcode: string;
  name: string;
  packMaterials: PackMaterial[];
  packServices: PackServices[];

  static getTableDefinition(): InternalTable {
    return new Pack().tableDefinition;
  }
}
